import React from 'react';
import PropTypes from 'prop-types';
import { useHistory, useParams } from 'react-router';
import {
  getQueryParams,
  getReturnUrlAndRestOfQueryParams,
  studentSubmissionPageUrl,
} from '../helpers/url';
import AssignmentClassDashboard from '../components/AssignmentClassDashboard/AssignmentClassDashboard';
import assignmentTypes from '../utils/assignmentTypes';

const getAssignmentParams = assignmentType => {
  const history = useHistory();
  const {
    assignmentInstanceId: assignmentInstanceIdFromParam,
    assignmentId,
  } = useParams();
  const {
    mloId,
    instructionalPlanId,
    contentId,
    academicYearId,
    assignmentInstanceId: assignmentInstanceIdFromQuery,
  } = getQueryParams(history);

  const assignmentInstanceId =
    assignmentInstanceIdFromParam || assignmentInstanceIdFromQuery;
  let assignmentParams = null;

  switch (assignmentType) {
    case assignmentTypes.TEACHER:
      assignmentParams = {
        assignmentInstanceId,
        mloId,
        instructionalPlanId,
        academicYearId,
        contentId: assignmentInstanceId,
        contentType: 'TEACHER_ASGN',
      };
      break;
    case assignmentTypes.ALEF:
      assignmentParams = {
        assignmentId,
        mloId,
        instructionalPlanId,
        contentId,
        academicYearId,
        contentType: 'ASGN',
      };
      break;

    default:
      throw new Error('assignmentType is not valid');
  }

  return assignmentParams;
};

const AssignmentClassDashboardPage = ({ assignmentType }) => {
  const history = useHistory();
  const returnUrl = getReturnUrlAndRestOfQueryParams();
  const {
    classId: classIdParam,
    isGradableItemsLockedByDefault,
  } = getQueryParams(history);

  const onGoBack = () => {
    window.location.href = `/teacher/?${Date.now()}${returnUrl}`;
  };

  const onNavigateToStudent = ({
    assignmentInstanceId,
    assignmentId,
    classId,
    mloId,
    studentId,
    contentId,
    academicYearId,
  }) =>
    history.push(
      studentSubmissionPageUrl({
        assignmentInstanceId,
        assignmentId,
        classId,
        mloId,
        studentId,
        contentId,
        academicYearId,
        returnUrl,
        isGradableItemsLockedByDefault,
      }),
    );

  return (
    <AssignmentClassDashboard
      teacherAssignmentParams={
        assignmentType === assignmentTypes.TEACHER
          ? getAssignmentParams(assignmentType)
          : undefined
      }
      alefAssignmentParams={
        assignmentType === assignmentTypes.ALEF
          ? getAssignmentParams(assignmentType)
          : undefined
      }
      isGradableItemsLockedByDefault={isGradableItemsLockedByDefault === 'true'}
      assignmentType={assignmentType}
      onGoBack={onGoBack}
      onNavigateToStudent={onNavigateToStudent}
      classId={classIdParam}
    />
  );
};

AssignmentClassDashboardPage.propTypes = {
  assignmentType: PropTypes.string.isRequired,
};

export default AssignmentClassDashboardPage;
